import { LOCALE } from 'src/dataLayer/env'

import awsApiClient from './awsApiClient'

const authenticate = () => awsApiClient.authenticate(LOCALE)

const apiClientFetch = async (requiresAuthentication, verb, payload) => {
  if (requiresAuthentication) {
    await authenticate()
  }
  return awsApiClient.fetch({ verb, ...payload })
}

const authenticatedGet = (payload) => apiClientFetch(true, 'GET', payload)

export { authenticate, authenticatedGet }
